import React from 'react';
import { useLayoutContext } from 'contexts/LayoutContext';
import api from 'lib/trpcClient';
import { CurrencyCode } from 'further-types/lp/vehicle';
import GeneralCapitalCallsContent from './GeneralCapitalCallsContent';
import { CalendarDay } from 'further-ui/utils';
import { useFormContext } from 'react-hook-form';
import { PartnerTransfersFormValues } from '../../hooks/usePartnerTransfersForm';

const TransferGeneralCapitalActions: React.FC<{
  partnerTransferId: string;
  baseCurrency: CurrencyCode;
  onNext: () => void;
  onPrevious: () => void;
}> = ({ partnerTransferId, baseCurrency, onNext, onPrevious }) => {
  const { selectedVehicleId } = useLayoutContext();
  const { getValues } = useFormContext<PartnerTransfersFormValues>();

  const [generalCapitalActions] =
    api.partnerTransfers.getGeneralCapitalActions.useSuspenseQuery(
      {
        partnerTransferId,
        vehicleId: selectedVehicleId ?? '',
      },
      {
        staleTime: 0,
        gcTime: 0,
      },
    );

  const transferDate = getValues('transferDate') ?? new CalendarDay(new Date());

  return (
    <GeneralCapitalCallsContent
      partnerTransferId={partnerTransferId}
      transferDate={transferDate}
      generalCapitalActions={generalCapitalActions.map(
        (generalCapitalAction) => ({
          ...generalCapitalAction,
          newInvestorBreakdown: generalCapitalAction.newInvestorBreakdown ?? [],
        }),
      )}
      baseCurrency={baseCurrency}
      onNext={onNext}
      onPrevious={onPrevious}
    />
  );
};

export default TransferGeneralCapitalActions;
